import React from "react";
import { Link } from "react-router-dom";
import { Anchor } from "antd";
import { MenuOutlined, CloseCircleOutlined } from "@ant-design/icons";

import $ from "jquery";
import { imgSrc } from "../../modules";

import "./header.css";

const menu = [{ name: "หน้าแรก", id: "home" }, { name: "บริการ", id: "services" }, { name: "พื้นที่ให้บริการ", id: "area" }, { name: "ทีมงานของเรา", id: "team" }, { name: "ติดต่อเรา", id: "contact" }];

class HeaderComponent extends React.Component {
    state = {
        menuActive: false,
    };

    toggleMenu = () => {
        this.setState({ menuActive: !this.state.menuActive });
    };

    slideTo = () => {
        $("html, body")
            .stop()
            .animate({ scrollTop: 0 }, 500, "swing");
    };

    componentDidMount = () => {
        $(window).scroll(() => {
            const top = $(window).scrollTop();
            if (top > 0 && !$("header").hasClass("sticky")) {
                $("header").addClass("sticky");
            } else if ($("header").hasClass("sticky") && top < 1) {
                $("header").removeClass("sticky");
            }
        });
    };

    render() {
        const { menuActive } = this.state;
        const { history } = this.props;
        return (
            <header>
                <div className="container">
                    <nav>
                        <div>
                            <Link to="/" onClick={this.slideTo}>
                                <img src={imgSrc("cpn-logo.png", false)} alt="บริษัท ซีพีเอ็น ทรานสปอร์ต จำกัด " />
                            </Link>
                        </div>
                        <div>
                            <Anchor affix={false} offsetTop={65} showInkInFixed={false} onClick={this.toggleMenu} className={menuActive ? "active" : ""}>
                                {menu.map((value, key) => {
                                    const hashTag = history.location.pathname === "/" ? "#" : "/#";
                                    return <Anchor.Link key={"menu_" + key} href={hashTag + value.id} title={value.name} />;
                                })}
                            </Anchor>
                            {!menuActive && <MenuOutlined id="menu-responsive" onClick={this.toggleMenu} />}
                            {menuActive && <CloseCircleOutlined id="menu-responsive" onClick={this.toggleMenu} />}
                        </div>
                    </nav>
                </div>
            </header>
        );
    }
}

export default HeaderComponent;
